import React               from "react";
import {Grid, makeStyles}                 from '@material-ui/core';

const useStyles = makeStyles(theme =>({
  questionContainer:{
    width: "100%",
    height:"100%",
  },
  reading: {
    width: "80%",
    margin:"10px 0 10px 0 ",
    font: '22px lato',
    letterSpacing: '0.21px',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",

    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",
 
    }, 
  },
  table: {
    width: "100%",
    font: '22px lato',
    margin: '0',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "16px lato",
 
    },
    [theme.breakpoints.down(925)]:{
      font: "14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "12px lato",

    }, 
  },
  tdTable: {
    padding: "0 1%",
    // border: '1px solid black',
  }
}));

const QuestionTable = (props) => {
  const classes = useStyles()

  return(
    <Grid container className={classes.questionContainer}>
      <p
        className={classes.reading}
      >
        4. Relaciona cada tipo de comercio con su inconveniente.
      </p>
      <br/>
      <table className={classes.table}>
        <thead>
          <th style={{width: "40%", textAlign: 'left'}}><i>Método</i></th>
          <th style={{width: "60%", textAlign: 'left'}}><i>Inconveniente</i></th>
        </thead>
        <tbody>
          <tr>
            <td className={classes.tdTable}>
              <p className={classes.table}> 
                1. Semillas
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                a. Ocupan mucho espacio y pesan.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                2. Billetes
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                b. Son falsificables.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                3. Monedas
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                c. Se echan a perder. 
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                4. Criptomonedas
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.table}>
                d. Generan problemas ambientales.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  )
}

export default QuestionTable;
